




























import Vue from "vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";
import WizardConnect from "@/components/organisms/wizard/WizardConnect.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import {
  getWizardExternalConfig,
  WizardExternalConfig,
} from "@/services/externalProvidersService";
import VaButton from "@/components/atoms/VaButton.vue";
import SingleColumn from "@/components/templates/SingleColumn.vue";

// Tenant codes of devices that predate WizardSetting.externalAccount and must
// keep the legacy Room wizard flow (updates/credentials/language steps).
// New tenants — even with deviceType "Room" — must NOT fall in here: they rely
// on wizardExternalConfig instead. The list lives only in env
// (VUE_APP_LEGACY_ROOM_TENANTS) so a forgotten tenant can be added without a
// code change.
const LEGACY_ROOM_TENANTS = (process.env.VUE_APP_LEGACY_ROOM_TENANTS ?? "")
  .split(",")
  .map((code: string) => code.trim())
  .filter(Boolean);

export default Vue.extend({
  name: "template_main",
  data() {
    return {
      deviceConfiguration: undefined as DeviceConfiguration | undefined,
    };
  },
  methods: {
    onConfigUpdated(config: DeviceConfiguration) {
      this.deviceConfiguration = config;
    },
  },
  computed: {
    wizardExternalConfig(): WizardExternalConfig {
      return getWizardExternalConfig(
        this.deviceConfiguration?.clientConfig?.wizardSetting
      );
    },
    isLegacyRoom(): boolean {
      if (this.deviceConfiguration?.deviceType !== "Room") return false;
      // A missing tenant code is assumed to be the historical Mago room.
      const tenantCode = this.deviceConfiguration.tenantCode || "REM-MAG-ROOM";
      return LEGACY_ROOM_TENANTS.includes(tenantCode);
    },
    steps(): string[] {
      let steps = ["license", "appearance"];
      if (this.isLegacyRoom) {
        steps = ["license", "updates", "credentials", "language", "appearance"];
      }
      if (this.wizardExternalConfig.hasCalendar) steps.push("calendar");
      if (this.wizardExternalConfig.hasMeeting) steps.push("meeting");
      steps.push("complete");
      return steps;
    },
  },
  components: {
    VaButton,
    WizardConnect,
    RoomWizard,
    SingleColumn,
  },
});
